/**
 * Cooldown gate for Control Centre Iceberg re-reads on focus / keep-alive.
 *
 * Returning within the interval intentionally skips a refresh (keeps stale
 * keep-alive state) to avoid hammering Trino — stamp via mark() whenever a
 * truth fetch starts so mount/period loads count toward the gap too.
 */

export type TruthRefreshCooldown = {
  /** Whether a visibility bump should proceed; stamps lastAt when true. */
  tryBump: (nowMs: number, force?: boolean) => boolean;
  /** Stamp without bumping (call when a truth fetch starts). */
  mark: (nowMs: number) => void;
  lastAt: () => number;
};

export function createTruthRefreshCooldown(
  minIntervalMs: number,
  initialLastAtMs = 0,
): TruthRefreshCooldown {
  let lastAtMs = initialLastAtMs;
  return {
    tryBump(nowMs, force = false) {
      if (
        !force
        && lastAtMs > 0
        && nowMs - lastAtMs < minIntervalMs
      ) {
        return false;
      }
      lastAtMs = nowMs;
      return true;
    },
    mark(nowMs) {
      lastAtMs = nowMs;
    },
    lastAt() {
      return lastAtMs;
    },
  };
}

export function shouldAllowTruthRefresh(
  lastAtMs: number,
  nowMs: number,
  minIntervalMs: number,
  force = false,
): boolean {
  if (force) return true;
  if (lastAtMs <= 0) return true;
  return nowMs - lastAtMs >= minIntervalMs;
}
